import { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'

import { IconLoading } from '@/assets/icons/icon-loading'
import { useToast } from '@/components/ui/toast.tsx'
import { ApplyTrialPromo } from '@/modules/promo/ui/apply-trial-promo'

export const ApplyPromoPage = () => {
  const toast = useToast()

  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  useEffect(() => {
    if (!token) {
      toast.error('Invalid link. Please check your email.')
      setTimeout(() => {
        window.location.href = 'https://creatorhero.com'
      }, 3000)
    }
  }, [token, toast])

  if (!token) {
    return (
      <div className="flex items-center justify-center h-screen">
        <IconLoading className="w-8 h-8 animate-spin text-primary" />
      </div>
    )
  }

  return <ApplyTrialPromo token={token} />
}
